import { render } from "./AppOverlayLoader.vue?vue&type=template&id=ed8ca7ee"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__